define('v3/Pages/Check/Components/CheckPupilGrid/ViewModels/CheckPupil.ViewModel',[
	'knockout',
	'lodash',
	'v3/Common/Models/enums',
	'v3/Common/Services/pageStateService'
], function (ko, _, enums, pageStateService) {
	function CheckPupilViewModel (subjectGroup, subjectPercentileModel, targetPercentile) {
		var self = this;

		subjectPercentileModel || (subjectPercentileModel = { percentile: 0, abilityPercentileState: enums.abilityPercentileState.notStarted });

		self.subjectGroupId = subjectGroup.id;
		self.subjectGroupName = subjectGroup.name;
		self.subjectGroupNameForSorting = subjectGroup.name;
		self.subjectGroupIconName = subjectGroup.subjectGroupIconName;

		self.abilityPercentile = subjectPercentileModel.percentile;
		self.abilityPercentileState = subjectPercentileModel.abilityPercentileState;
		self.targetPercentile = targetPercentile;

		self.abilityGrowth = null;
		self.targetAbilityGrowth = null;
		self.currentScore = null;
		self.abilityObjectType = ko.observable(enums.chartLevel.subject);
		self.selectedPupil = {
			userId: pageStateService.getStringObservable('pupilId'),
			name: pageStateService.getStringObservable('pupilName')
		};

		self.selectedSubjectGroup = ko.observable(false);
		self.subDomains = ko.observableArray([]);
		self.isRainBowChartLoaded = ko.observable(false);

		self.hasSelectedSubDomains = ko.computed(function () {
			return _.filter(self.subDomains(), function (sd) {
				if (sd.selected()) {
					return true;
				} else {
					return false;
				}
			}).length > 0;
		});

		self.hasAllSubdomainsSelected = function () {
			var allSelected = self.subDomains().filter(function (subDomain) {
				return subDomain.selected();
			}).length === self.subDomains().length;

			return allSelected;
		};

		self.isSubDomainsLoading = ko.observable(false);
		self.showSubjectGroupSubDomains = ko.observable(false);

		self.actualGrowth = ko.observable(null);
		self.expectedGrowth = ko.observable(null);
		self.score = ko.observable(null);

		self.updateSubjectGroupAbilityGrowth = function (pupilAbilityGrowth) {
			if (_.isFinite(pupilAbilityGrowth.score)) {
				self.currentScore = pupilAbilityGrowth.score;
				self.score(pupilAbilityGrowth.score);
			} else {
				self.abilityGrowth = pupilAbilityGrowth.abilityGrowth;
				self.targetAbilityGrowth = pupilAbilityGrowth.targetAbilityGrowth;
				self.actualGrowth(pupilAbilityGrowth.abilityGrowth);
				self.expectedGrowth(pupilAbilityGrowth.targetAbilityGrowth);
			}
		};

		self.toggleSubdomains = function () {
			var allSelected = self.hasAllSubdomainsSelected();

			self.subDomains().forEach(function (subDomain) {
				subDomain.selected(!allSelected);
			});
		};

		self.abilityGrowthPercent = null;
		self.targetAbilityGrowthPercent = null;

		self.pupilDAE = ko.observable(null);
		self.isDLEVisible = ko.observable(false);
	}

	return CheckPupilViewModel;
});
